import Dashboard from '../views/Dashboard.vue'
import Authentication from '../views/Authentication.vue'


import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
	if (!store.getters.user) {
		next ()
		return
	}
	next ('/')
}

const ifAuthenticated = (to, from, next) => {
	if (store.getters.user) {
		// TODO: Usare questa condizione per loggare solo con email verificate
		//if (store.getters.user && store.getters.user.emailVerified) {
		next ()
		return
	}
	next ('/login')
}

export const routes = [
	{ 
		name: 'Authentication',
		path: '/login',
		component: Authentication,
		beforeEnter: ifNotAuthenticated,
	},
	{
		path: '/',
		name: 'Dashboard',
		component: Dashboard,
		beforeEnter: ifAuthenticated
	}
]
